export default __webpack_public_path__ + "static/media/Arm_right.826bb48d.svg";